import { render } from "./hairSalongBar.vue?vue&type=template&id=bf3346b0&scoped=true"
import script from "./hairSalongBar.vue?vue&type=script&lang=js"
export * from "./hairSalongBar.vue?vue&type=script&lang=js"

import "./hairSalongBar.vue?vue&type=style&index=0&id=bf3346b0&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3346b0"]])

export default __exports__